import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CumpleFilterDates } from "src/common/cumples";
import { CumplesState, selectAll, selectEntities, selectTotal } from "./cumples.reducer";


export const cumplesState = createFeatureSelector<CumplesState>("cumples");

export const CUMPLES_DATE_SEP: string = "/";

export const cumplesReady = createSelector(
	cumplesState,
	state => state.ready
);

export const cumplesAll = createSelector(
	cumplesState,
	selectAll
);

export const cumplesTotal = createSelector(
	cumplesState,
	selectTotal
);

export const cumplesEntityFunc = createSelector(
	cumplesState,
	state => ( idUsuarioMf: number ) => state.entities? state.entities[ idUsuarioMf ]: null
);

export const cumplesEnvioReady = createSelector(
	cumplesState,
	state => state.envioReady
);

export const cumplesUsuarioFoto = createSelector(
	cumplesState,
	state => ( idUsuarioMf: number ) => state.usuariosFoto? state.usuariosFoto[ idUsuarioMf ]: null
);

export const cumplesFilterDates = createSelector(
	cumplesState,
	state => {
		let dates: CumpleFilterDates;
		if( state.filter.actualDate && state.filter.dates ) {
			let startDate: string = state.filter.actualDate;
			dates = { ...state.filter.dates, startDate };
		} else
			dates = state.filter.dates;
		return dates;
	}
);

export const cumplesFilterReady = createSelector(
	cumplesState,
	state => state.filter.ready
);

export const cumplesFilterActualDate = createSelector(
	cumplesState,
	state => state.filter.actualDate
);

export const cumplesToday = createSelector(
	cumplesState,
	state => state.filter.dates? state.filter.dates.startDate: null
);

export const cumplesFuncionesIdUsuarioMf = createSelector(
	cumplesState,
	state => state.info? state.info.idUsuarioMf: null
);

export const cumplesUsuarioFunciones = createSelector(
	cumplesState,
	state => state.info? state.info.funciones: null
);

export const cumplesUsuarioFuncionesReady = createSelector(
	cumplesState,
	state => state.info? state.info.ready: null
);
